import React, { createContext, useContext, useState, useMemo, useRef } from 'react';

const PlayerContext = createContext();

export const PlayerProvider = ({ children }) => {
  const pendingRosterFilter = useRef(null);
  // 🔹 State variables
  const [playerData, setPlayerData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [originalPlayerData, setSavedOriginalPlayerData] = useState([]);
  const [playerID, setPlayerID] = useState('');
  const [listLoadID, setListLoadID] = useState('');
  const [thePlayerTotal, setPlayerTotal] = useState(0);
  const [playerDataLength, setPlayerDataLength] = useState(0); // ✅ Added missing state
  const [activeFilter, setActiveFilter] = useState(''); // ✅ Added missing state
  const [activePlayer, setActivePlayer] = useState([]); // ✅ Added missing state
  const [activeReports, setActiveReports] = useState([]); // ✅ Added missing state
  const [playerIDFiltered, setPlayerIDFiltered] = useState('');
  const [reportsSet, setReportsSet] = useState(null);

// Add to memoizedState
const memoizedState = useMemo(() => ({
  playerData,  // Array of Players
  filteredData, // Array of Players after filtering
  originalPlayerData,  //Array of Players as saved from initial load
  playerID, // Currently selected Player ID
  playerIDFiltered, //ID of First Player in Filtered List
  listLoadID, //Random Number generated to make sure One Liner uses NEW data
  thePlayerTotal, //The total number of players in the current dataset
  playerDataLength, // Length of the playerData array
  activeFilter, // Currently active filter
  activePlayer, // Currently active player object
  activeReports,// Current Active Reports for Scout Reports
  reportsSet,
}), [playerData, filteredData, originalPlayerData, playerID, playerIDFiltered, listLoadID, thePlayerTotal, playerDataLength, activeFilter, activePlayer, activeReports]);

// Add to memoizedActions
const memoizedActions = useMemo(() => ({
  pendingRosterFilter,
  setPlayerData,
  setFilteredData,
  setSavedOriginalPlayerData,
  setPlayerTotal,
  setPlayerID,
  setPlayerIDFiltered, // ✅ new
  setListLoadID,
  setPlayerDataLength,
  setActiveFilter,
  setActivePlayer,
  setActiveReports,
  setReportsSet,
}), []);


  return (
    <PlayerContext.Provider value={{ ...memoizedState, ...memoizedActions }}>
      {children}
    </PlayerContext.Provider>
  );
};

// 🔹 Custom Hook for Context Access
export const usePlayer = () => {
  const context = useContext(PlayerContext);
  if (!context) {
    throw new Error('usePlayer must be used within a PlayerProvider');
  }
  return context;
};
